export function isAbsoluteHttpUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}

/** 站内路径：`/path`，排除协议相对地址 `//host` */
export function isInternalAppPath(url: string): boolean {
  return url.startsWith("/") && !url.startsWith("//");
}

export function navigateByMessagePath(
  messagePath: string,
  navigate: (path: string) => void
): void {
  const url = messagePath.trim();
  if (!url) return;

  if (isAbsoluteHttpUrl(url)) {
    window.open(url, "_blank");
    return;
  }

  if (isInternalAppPath(url)) {
    navigate(url);
    return;
  }

  window.open(url, "_blank");
}
